/* src/app/components/shared/molecules/popover/popover.component.scss */
.popover-trigger {
  display: inline-flex;
  cursor: pointer;
}
/*# sourceMappingURL=popover.component-FOWLTWV4.css.map */
